import { Component, OnInit,ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../_models';
import { UserService } from '../_services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/_services/notification.service';
import { TicketsService } from 'src/app/_services/tickets.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
interface License {
  quantity: number;
  status: string;
  isTrial: boolean;
  offerName: string;
  friendlyName: string;
  subscriptionId: string;
  upCount: number; // to store license edited value
  isEdit: boolean; // to perform inline editing
  billingCycle: string // annual monthly none one_time triennial unknown
}

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css'],
})
export class SubscriptionComponent implements OnInit {
  displayedColumns: string[] = [
    'no',
    'license',
    'billingCycle',
    'termCycle',
    "autoRenewal",
    "renewalDate",
    'status',
    'licenseQuantity',
    'actions',
    
  ]; //'trial' , 'editActions'
  dataSource;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  total: number;
  loading = true;
  fetchLoader = true;
  error = '';
  arr;
  isUserLoggedIn = false;
  title = 'materialApp'; 
  color = 'primary';
  mode = 'indeterminate';
  value = 75;
  diameter=60
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public userId: string;
  public partnerCenterId: string; // Adding custom element for PartnerCenter
  public email: string;
  public company: string;
  updateSub: boolean = false;
  editSub: boolean = true;
  public userStatus: string; // Added for Filtering function
  filterDataSource; // Added for Filtering function

  constructor(
    public ticketservice: TicketsService,
    private router: Router,
    private notifyService: NotificationService
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.userId = this.currentUserSubject.value.userId;
    this.isUserLoggedIn = this.currentUser == null ? false : true;
    // Modified
    this.partnerCenterId = this.currentUserSubject.value.partnerCenterId;
    this.email = this.currentUserSubject.value.email;
    this.company = this.currentUserSubject.value.companyName;

    ticketservice.getMySubscriptionList(this.partnerCenterId).subscribe(
      (res) => {
        // Fetching Licenses from API
        notifyService.showInfo('Data Loaded successfully', '');
        this.dataSource = res['license'];
        // To update the upCount value with the License quantity
        this.dataSource.forEach((license) => {
          // console.log(license);
          license.upCount = license.quantity;
          license.isEdit = false;
        });


        this.total = this.dataSource.length;
        this.loading = false;
        this.fetchLoader = false
        this.setCustomers();
      },
      (error) => {
        this.error = error;
        notifyService.showWarning('Failed retreiving data', '');
        this.loading = false;
        this.fetchLoader = false
      }
    );
  }

  ngOnInit(): void {
    this.userStatus = 'active';
    this.filterDataSource.paginator = this.paginator;    

  }

  alertBts() {
    this.updateSub = true;
    this.editSub = false;
  }

  resetSub() {
    this.editSub = true;
    this.updateSub = false;
    this.dataSource.forEach((license) => (license.upCount = license.quantity));
  }

  updateMySub(
    quantity: number,
    subId: string,
    initialQuantity: number,
    licenseName: string,
    currentSubscription: any
  ) {
    if (quantity <= 0) {
      alert('Kindly write to iLink CSP team to deactivate subscription');
      this.notifyService.showWarning(
        'Kindly write to iLink CSP team to deactivate subscription',
        ''
      );
      this.dataSource.forEach(
        (license) => (license.upCount = license.quantity)
      );
      return '';
    }
    // Removing maximum license update count
    // if (quantity >= 300) {
    //   alert('Maximum allowed quantity is upto 300');
    //   this.notifyService.showWarning(
    //     'Maximum allowed quantity is upto 300',
    //     ''
    //   );
    //   this.dataSource.forEach(
    //     (license) => (license.upCount = license.quantity)
    //   );
    //   return '';
    // }
    this.loading = true;
    this.ticketservice
      .updateSubscription(
        quantity,
        this.partnerCenterId,
        subId,
        initialQuantity,
        this.email,
        this.company,
        licenseName,
        currentSubscription
      )
      .subscribe(
        (result) => {
          // Fetching Licenses from API
          this.loading = false;
          setTimeout(() => {
            this.notifyService.showSuccess(
              'License Quantity updated successfully',
              'Success'
            );
            window.location.reload();
          }, 2000);
          alert('Success. Reloading');
          // window.location.href = "#/subscription";
          // window.location.reload();
        },
        (error) => {
          console.warn(error);
          this.error = error;
          this.loading = false;
          setTimeout(() => {
            this.notifyService.showError(error,'Failed updating the subscription',);
            window.location.reload();
          }, 2000);
          alert(error);
          // window.location.reload();
        }
      );
  }

  setCustomers() {
    this.arr = this.dataSource;
    if (this.userStatus != 'all') {
      this.arr = this.dataSource.filter(
        (license) => license.status == this.userStatus
      );
    }
    this.filterDataSource = new MatTableDataSource(this.arr)
    this.filterDataSource.paginator = this.paginator 
  }

  OnStatusChange() {
    this.setCustomers();
  }
}
